import { createContext, type PropsWithChildren, use, useCallback, useState } from "react";

interface MobileMenuContext {
    isMobileMenuOpen: boolean;
    toggleMobileMenu: () => void;
}

const MobileMenuContext = createContext<MobileMenuContext>({
    isMobileMenuOpen: false,
    toggleMobileMenu: () => {}
});

export const MobileMenuProvider = ({ children }: PropsWithChildren) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = useCallback(() => {
        setIsMobileMenuOpen(prevState => !prevState);
    }, []);

    return (
        <MobileMenuContext value={{ isMobileMenuOpen, toggleMobileMenu }}>
            {children}
        </MobileMenuContext>
    );
};

export const useMobileMenuContext = () => {
    const context = use(MobileMenuContext);
    if (!context) {
        throw new Error("useMobileMenuContext must be used within an MobileMenuProvider");
    }

    return context;
};
